import React, { FC, ReactElement } from 'react';
import { connect } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { SingleValue } from 'react-select/dist/declarations/src/types';
import { Client, SearchClientData } from '../../services/typings';
import { fetchClient, mapClientFields, searchClients } from '../../services/client';
import { useBadgeReader, UseBadgeReaderOptions } from './hooks';
import { State } from '../../reducers/typings';
import { SearchClientOption, DEFAULT_CLIENT } from './helper';

export interface Props extends UseBadgeReaderOptions {
  selectedClient?: Client;
  warehouseId: number;
}

const ClientSelector: FC<Props> = ({
  selectedClient = DEFAULT_CLIENT,
  warehouseId,
  changeClient,
  setSnackBarMessage,
}: Props): ReactElement => {
  useBadgeReader({ changeClient, setSnackBarMessage, warehouseId });
  let selectedOption: SearchClientOption | null = null;
  if (selectedClient.fullName) {
    selectedOption = {
      label: `${selectedClient.fullName} ${
        selectedClient.email ? `(${selectedClient.email})` : ''
      } // ${selectedClient.credit / 100}€`,
      value: String(selectedClient.clientId),
    };
  }

  return (
    <AsyncSelect<SearchClientOption>
      isClearable
      placeholder="Sélectionner le mail du convive"
      inputId="client"
      value={selectedOption}
      onChange={(option: SingleValue<SearchClientOption>): void => {
        if (option) {
          fetchClient(option.value).then(client => changeClient(mapClientFields(client)));
        }
      }}
      loadOptions={async (inputValue: string) => {
        if (inputValue.length < 3) {
          return [];
        }
        const clients = await searchClients({ searchBy: 'email', searchCriteria: inputValue });
        return clients.map(
          (client_data: SearchClientData): SearchClientOption => ({
            label: client_data.user.username,
            value: String(client_data.id),
          }),
        );
      }}
    />
  );
};

function mapStateToProps(state: State): Pick<Props, 'warehouseId'> {
  return {
    warehouseId: state.warehouse.warehouseId,
  };
}

export default connect(mapStateToProps)(ClientSelector);
